import api from './api';

class ScoreAPI {
    // Submit match score
    async submitScore(matchId, scores, teamId = null) {
        try {
            // Prepare score data with same logic as before
            const scoreData = {
                scores: {
                    team1_set1: parseInt(scores.team1_set1),
                    team1_set2: parseInt(scores.team1_set2),
                    team1_set3: scores.team1_set3 ? parseInt(scores.team1_set3) : null,
                    team2_set1: parseInt(scores.team2_set1),
                    team2_set2: parseInt(scores.team2_set2),
                    team2_set3: scores.team2_set3 ? parseInt(scores.team2_set3) : null
                }
            };

            // Use centralized api instance (token added automatically via interceptor)
            const config = teamId ? { params: { team_id: teamId } } : undefined;
            return await api.post(`/scores/submit/${matchId}`, scoreData, config);
        } catch (error) {
            console.error('Error submitting score:', error);
            // Re-throw with user-friendly message if available
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    // Get score verification link for opponent
    async getScoreVerificationLink(matchId, teamId = null) {
        try {
            // Use centralized api instance (token added automatically via interceptor)
            const config = teamId ? { params: { team_id: teamId } } : undefined;
            return await api.get(`/scores/verification-link/${matchId}`, config);
        } catch (error) {
            console.error('Error getting verification link:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    // Verify score (for opponent) - new API structure
    async verifyScore(scoreConfirmationId, action, disputeMessage = null) {
        try {
            const requestData = {
                action: action, // 'confirm' or 'dispute'
                disputeMessage: disputeMessage // Only for disputes
            };

            // Use centralized api instance (token added automatically via interceptor)
            return await api.post(`/scores/verify/${scoreConfirmationId}`, requestData);
        } catch (error) {
            console.error('Error verifying score:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    // Get score verification details
    async getScoreVerificationDetails(verificationToken) {
        try {
            // Use centralized api instance (no token needed for public verification)
            return await api.get(`/scores/verification-details/${verificationToken}`);
        } catch (error) {
            console.error('Error getting verification details:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    // Get pending score verifications for a team
    async getPendingVerifications(teamId) {
        try {
            // Use centralized api instance (token added automatically via interceptor)
            return await api.get(`/scores/pending-verifications/${teamId}`);
        } catch (error) {
            console.error('Error getting pending verifications:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    // Get opponent team members for a match
    async getOpponentTeamMembers(matchId, teamId = null) {
        try {
            // Use centralized api instance (token added automatically via interceptor)
            const config = teamId ? { params: { team_id: teamId } } : undefined;
            return await api.get(`/scores/opponent-members/${matchId}`, config);
        } catch (error) {
            console.error('Error getting opponent team members:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }

    async getOpponentTeamSheet(matchId, teamId = null) {
        try {
            const config = teamId ? { params: { team_id: teamId } } : undefined;
            return await api.get(`/scores/opponent-team-sheet/${matchId}`, config);
        } catch (error) {
            console.error('Error getting opponent team sheet:', error);
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw error;
        }
    }
}

export default new ScoreAPI();
